var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "360.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 360.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#601bcf",
    d: "M300 1005 c0 -256 2 -465 5 -465 3 0 48 35 100 77 l95 77 0 67 0 66 -60 7 c-33 4 -60 11 -60 16 0 6 7 10 16 10 24 0 116 46 154 79 19 16 44 44 54 62 l19 34 -24 -22 c-13 -12 -41 -29 -62 -38 l-37 -15 20 37 c25 47 26 104 3 125 -10 9 -35 23 -55 31 -41 17 -46 28 -23 47 8 7 15 18 15 24 0 6 6 23 14 37 8 16 10 32 5 40 -10 16 7 29 40 29 16 0 36 14 60 42 19 22 55 54 80 70 l45 28 -202 0 -202 0 0 -465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#601bcf",
    d: "M768 1425 c22 -19 54 -63 73 -97 30 -56 33 -72 34 -143 0 -71 -4 -88 -33 -147 -43 -89 -123 -156 -222 -189 -16 -6 8 -8 66 -6 80 3 100 7 157 35 115 57 168 145 168 277 0 137 -67 239 -184 284 -88 32 -105 28 -59 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1594 1316 c-11 -28 1 -51 28 -54 31 -4 48 29 28 53 -16 19 -49 19 -56 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2610 1308 c-43 -20 -44 -21 -20 -27 l25 -7 3 -212 2 -212 -22 -10 c-17 -6 -1 -9 57 -9 44 1 73 3 65 6 -37 13 -40 32 -40 265 0 176 -3 228 -12 228 -7 0 -33 -10 -58 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2828 1312 c-42 -19 -49 -32 -18 -32 28 0 31 -22 28 -235 l-3 -189 -25 -13 c-22 -11 -15 -13 60 -12 51 1 75 4 60 8 l-25 7 -3 242 c-3 271 2 257 -74 224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2109 1229 c-9 -19 -34 -50 -55 -67 l-39 -32 28 0 27 0 0 -119 c0 -117 9 -168 33 -183 27 -17 66 -8 92 23 28 34 26 52 -3 26 -47 -43 -63 -7 -60 135 l3 113 38 3 c20 2 37 7 37 12 0 5 -17 10 -37 12 l-38 3 -5 55 -5 55 -16 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1200 1138 c-43 -20 -44 -21 -20 -27 l25 -7 3 -202 2 -203 -32 -14 c-32 -14 -29 -14 62 -14 73 0 89 3 70 10 -35 14 -40 26 -40 99 0 50 3 61 12 52 18 -18 105 -15 138 5 94 55 100 261 9 308 -45 24 -84 19 -124 -16 l-35 -31 0 31 c0 36 -8 37 -70 9z m182 -48 c37 -29 51 -71 46 -140 -5 -73 -33 -110 -84 -110 -54 0 -74 36 -74 135 0 81 1 84 31 109 37 31 49 32 81 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1580 1137 c-43 -20 -44 -21 -17 -25 l28 -3 -3 -132 c-3 -130 -3 -131 -28 -138 -15 -4 11 -7 60 -7 47 0 78 2 70 5 -35 12 -40 35 -40 180 0 108 -3 143 -12 142 -7 0 -33 -10 -58 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1797 1140 c-60 -47 -43 -123 36 -165 67 -36 97 -63 97 -90 0 -76 -125 -52 -146 29 -11 45 -24 28 -24 -32 l0 -57 83 -3 c79 -3 85 -1 110 24 20 20 27 37 27 66 0 47 -24 75 -98 112 -61 31 -85 61 -71 87 24 46 97 30 123 -25 9 -20 19 -36 21 -36 3 0 5 24 5 53 l0 52 -69 3 c-56 2 -73 -1 -94 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2329 1137 c-47 -31 -69 -80 -69 -150 0 -107 51 -167 143 -167 50 0 88 24 112 70 27 52 18 68 -15 28 -37 -45 -70 -54 -117 -32 -37 18 -72 77 -73 122 0 21 3 22 110 22 104 0 110 1 110 20 0 90 -120 142 -201 87z m103 -24 c9 -10 19 -28 22 -40 7 -22 6 -23 -68 -23 -84 0 -92 7 -55 54 25 31 77 36 101 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3069 1138 c-52 -29 -79 -82 -79 -152 0 -65 16 -103 60 -140 26 -22 41 -26 90 -26 52 0 64 4 94 30 45 40 70 105 63 166 -13 115 -132 178 -228 122z m110 -24 c35 -29 51 -77 51 -152 0 -94 -49 -145 -108 -111 -79 44 -94 240 -22 276 35 18 44 16 79 -13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.734c4039c3b2be691725f69629e96d91.svg";
export { ForwardRef as ReactComponent };